var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/Update.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const Update = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M12 6.00018V7.79018C12 8.24018 12.54 8.46019 12.85 8.14018L15.64 5.35018C15.84 5.15018 15.84 4.84018 15.64 4.64018L12.85 1.85018C12.54 1.54018 12 1.76018 12 2.21018V4.00018C7.58 4.00018 4 7.58018 4 12.0002C4 13.0402 4.2 14.0402 4.57 14.9502C4.84 15.6202 5.7 15.8002 6.21 15.2902C6.48 15.0202 6.59 14.6102 6.44 14.2502C6.15 13.5602 6 12.7902 6 12.0002C6 8.69019 8.69 6.00018 12 6.00018ZM17.79 8.71018C17.52 8.98018 17.41 9.40019 17.56 9.75019C17.84 10.4502 18 11.2102 18 12.0002C18 15.3102 15.31 18.0002 12 18.0002V16.2102C12 15.7602 11.46 15.5402 11.15 15.8602L8.36 18.6502C8.16 18.8502 8.16 19.1602 8.36 19.3602L11.15 22.1502C11.46 22.4602 12 22.2402 12 21.8002V20.0002C16.42 20.0002 20 16.4202 20 12.0002C20 10.9602 19.8 9.96019 19.43 9.05018C19.16 8.38018 18.3 8.20018 17.79 8.71018Z",
    fill: color
  })
});